















































import { Component, Prop, Vue } from 'vue-property-decorator'
import ClickOutside from 'v-click-outside'
import Bubble from '../Bubble.vue'
import EditProjects, { EditProjectPayload } from '../EditProjects.vue'
import { Project } from '@shared/types/database'
import EditBubble from './EditBubble.vue'
import HoverBox from './HoverBox.vue'

@Component({
  components: {
    EditProjects,
    Bubble,
    EditBubble,
    HoverBox
  },
  directives: { clickOutside: ClickOutside.directive }
})
export default class Projects extends Vue {
  @Prop({ required: true }) readonly associatedProjects!: Project[]

  showList: boolean = false
  showCount = 2
  showMore = false

  toggle () {
    this.showList = !this.showList
  }

  editProject (data: EditProjectPayload) {
    this.$emit('edit-project', data)
  }

  close () {
    this.showList = false
  }
}
